import React from 'react';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../../../components/buttons/ButtonNavigation';
import PolicyRules from './SubComponents/PolicyRules';
import { PAYROLL_POLICY_STEP } from '../Model/Model';
import ButtonIcon from '../../../../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../../../../components/buttons/IconButtons';
import PolicyDetails from './SubComponents/PolicyDetails';
import StepTab from '../../../../../../../components/StepperTabs/StepTab';
import HeadTittle from '../../../../../../../components/HeadTittle';
import DivContainerBody from '../../../../../../../components/DivContainerBody';
import StepperTabs from '../../../../../../../components/StepperTabs/StepperTabs';
import PolicySummary from './SubComponents/PolicySummary';
import CommonPolicyApp from './Functionality/CommonPolicyApp';
import CreatePolicyApp from './Functionality/CreatePolicyApp';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CreatePayrollPolicy = () => {
    const {
        t,
        navigate,
        isGlobal,
        item,
        setItem,
        handleChange,
        emptyFields,
        setEmptyFields,
        activeStep,
        setActiveStep,
        steps,
        departments,
        setDepartments,
        handleStepChange,
        handleReorderRules,
        handleNextSummary,
        goBack,
        rule,
        setRule,
        updateRuleField,
        ruleEmptyFields,
        setRuleEmptyFields,
        ruleIsValid,
        ruleIsValidCalculationValue,
        ruleIsValidCalculationValueText,
        handleAddRule,
        removeRule,
        cleanChipSearch,
        setCleanChipSearch
    } = CommonPolicyApp();

    const {
        handleCreate,
        handleClearDetails,
        handleClearRules
    } = CreatePolicyApp({
        t,
        item,
        setItem,
        departments,
        navigate,
        isGlobal,
        setEmptyFields,
        setRuleEmptyFields,
        setRule,
        setCleanChipSearch,
        goBack
    });

    return (
        <>
            <HeadTittle onBack={goBack} name='create' />
            <DivContainerBody>
                <StepperTabs
                    id={null}
                    disabled={false}
                    steps={steps}
                    activeStep={activeStep}
                    isStepOptional={() => false}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                >
                    <StepTab index={PAYROLL_POLICY_STEP.DETAILS} activeStep={activeStep} normalHeight={true}>
                        {!item?.id && (
                            <div className='col-12 d-flex justify-content-end mb-4'>
                                <ButtonIcon
                                    className='btn-clean-secondary-600'
                                    id='btn_cpp_clean_details'
                                    Icon={CleanIcon}
                                    title={'clear_instances'}
                                    onClick={handleClearDetails}
                                />
                            </div>
                        )}
                        <PolicyDetails
                            item={item}
                            setItem={setItem}
                            handleChange={handleChange}
                            emptyFields={emptyFields}
                            selectedList={departments}
                            setSelectedList={setDepartments}
                            showInheritedConfigLegend={true}
                            cleanChipSearch={cleanChipSearch}
                            setCleanChipSearch={setCleanChipSearch}
                        />
                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mt-5 mb-60px'>
                            <ButtonNextStep
                                id='btn_cpp_next_rules'
                                text='next'
                                click={() => {
                                    if (!item.isValidDetails({ departments })) {
                                        setEmptyFields(true);
                                        return;
                                    }
                                    setEmptyFields(false);
                                    setActiveStep((prev) => prev + 1);
                                }}
                            />
                        </div>
                    </StepTab>

                    <StepTab index={PAYROLL_POLICY_STEP.RULES} activeStep={activeStep} normalHeight={true}>
                        {activeStep === PAYROLL_POLICY_STEP.RULES && (
                            <>
                                {!item?.id && (
                                    <div className='col-12 d-flex justify-content-end mb-4'>
                                        <ButtonIcon
                                            className='btn-clean-secondary-600'
                                            id='btn_cpp_clean_rules'
                                            Icon={CleanIcon}
                                            title={'clear_instances'}
                                            onClick={handleClearRules}
                                        />
                                    </div>
                                )}
                                <PolicyRules
                                    item={item}
                                    rule={rule}
                                    updateRuleField={updateRuleField}
                                    ruleEmptyFields={ruleEmptyFields}
                                    ruleIsValid={ruleIsValid}
                                    ruleIsValidCalculationValue={ruleIsValidCalculationValue}
                                    ruleIsValidCalculationValueText={ruleIsValidCalculationValueText}
                                    handleAddRule={handleAddRule}
                                    onDragEnd={handleReorderRules}
                                    onDeleteRule={removeRule}
                                />
                            </>
                        )}
                        <div className='d-flex justify-content-between px-0 mt-4 mb-60px'>
                            <ButtonPrevStep
                                id='btn_cpp_back_details'
                                text='back'
                                click={() => setActiveStep((prev) => prev - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cpp_next_summary'
                                text='next'
                                click={handleNextSummary}
                            />
                        </div>
                    </StepTab>

                    <StepTab index={PAYROLL_POLICY_STEP.SUMMARY} activeStep={activeStep} normalHeight={true}>
                        {activeStep === PAYROLL_POLICY_STEP.SUMMARY &&
                            <PolicySummary
                                item={item}
                                isGlobal={isGlobal}
                                departments={departments}
                            />
                        }
                        <div className='d-flex justify-content-between px-0 mt-4 mb-60px'>
                            <ButtonPrevStep
                                id='btn_cpp_back_rules'
                                text='back'
                                click={() => setActiveStep((prev) => prev - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cpp_create'
                                text='create'
                                click={handleCreate}
                            />
                        </div>
                    </StepTab>
                </StepperTabs>
            </DivContainerBody>
        </>
    );
};

export default CreatePayrollPolicy;
